import React from 'react';
import PropTypes from 'prop-types';
import autoBind from 'react-autobind';
import FlatButton from 'material-ui/FlatButton';
import Avatar from 'material-ui/Avatar';
import HelpToolTip from '../../components/HelpToolTip';
import './style.scss';

const UserAvatar = ({ src }) => (
  <Avatar src={src || '/img/default-profile.png'} style={{ marginRight: 15 }} />
);

class FieldProfileImage extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this._refs = {};
  }

  handleChange({ name, value }) {
    this.props.onChange({ name, value });
  }

  handleImageChange(event) {
    if (event.target.files[0]) {
      const file = event.target.files[0];
      const reader = new window.FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.props.onChange({
          name: this.props.name,
          value: {
            path: reader.result,
            name: file.name,
            key: this.props.value.key
          }
        });
      };
      reader.onerror = function(error) {
        console.log('Base 64 Error: ', error);
      };
    }
  }

  handleIconClick() {
    // Trigger a click on the hidden file input to
    // invoke native file upload
    this._refs.image.click();
  }

  render() {
    return (
      <div className="field-profile-image" style={{ position: 'relative' }}>
        <input
          onChange={this.handleImageChange}
          type="file"
          ref={ref => {
            this._refs.image = ref;
          }}
          className="hidden"
        />
        {this.props.tooltip && (
          <HelpToolTip
            style={{ position: 'absolute', left: 48, top: 12 }}
            tip={this.props.tooltip}
          />
        )}
        <UserAvatar src={this.props.value.path} />
        <FlatButton onClick={this.handleIconClick} label="Upload" />
      </div>
    );
  }
}

FieldProfileImage.propTypes = {
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired, // path
  value: PropTypes.object.isRequired // the whole image object
};

// FieldProfileImage.defaultProps = {
//   value: ''
// }

export default FieldProfileImage;



// WEBPACK FOOTER //
// ./src/components/FieldProfileImage/index.jsx